import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=6df9dfb4&scoped=true&"
import script from "./resources.vue?vue&type=script&lang=ts&"
export * from "./resources.vue?vue&type=script&lang=ts&"
import style0 from "./resources.vue?vue&type=style&index=0&id=6df9dfb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9dfb4",
  null
  
)

export default component.exports